export default {
  getCategories(brand_id){
    return new Promise((resolve, reject) => {
      axios.get('/api/topic/categories',{
        params:{
          brand_id:brand_id
        }
      })
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    }) 
  },
  SaveTopic(params){
    return new Promise((resolve, reject) => {
      axios.post('/api/topic/add',params)
      .then((response) => {
        resolve(response)
      })
    }, err => {
      reject(err)
    }) 
  },
}